<template>
  <Dialog :hide-close-button="true" v-bind="$attrs">
    <template #header-title> Saiba mais </template>
    <template #content>
      Sua simulação está em análise com a Loft e isso pode levar alguns minutos.
      Mas não se preocupe, caso tenha uma oferta pré-aprovada, você receberá um
      e-mail ou SMS.
    </template>
    <template #footer>
      <Button type="ghost" @click="$emit('close')">Fechar</Button>
    </template>
  </Dialog>
</template>
<script>
import Button from '@/aasgard/components/buttons/Button.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
export default {
  name: 'CredihomePartnerValidatingStepsBottomSheet',
  components: {
    Button,
    Dialog,
  },
  emits: ['close'],
}
</script>
<style lang="scss"></style>
